import { MAX_LOAD_LOCATIONS, type Workflow } from '@fv/models'

import { ShipmentLocationForm } from '../shipment-location-form/ShipmentLocationForm'
import type { ShipmentLocationFormModel } from '../shipment-location-form/types'

type Props = {
  workflow: Workflow
  value: ShipmentLocationFormModel[]
  onChange: (locations: ShipmentLocationFormModel[]) => void
  onSchedulePickupChange?: (schedule: boolean) => void
  schedulePickup?: boolean
  requireOriginEmail?: boolean
  onAddStop?: (afterSequence: number) => void
  onRemoveStop?: (sequence: number) => void
}
export const ShipmentFormLocations = ({
  value,
  workflow,
  onChange,
  onSchedulePickupChange,
  schedulePickup,
  requireOriginEmail,
  onAddStop,
  onRemoveStop,
}: Props) => {
  const handleChange =
    (sequence: number) => (updates: Partial<ShipmentLocationFormModel>) => {
      onChange(
        value.map(loc =>
          loc.sequence === sequence ? { ...loc, ...updates } : loc,
        ),
      )
    }

  return (
    <>
      {value.map(loc => (
        <ShipmentLocationForm
          key={loc.id ?? loc.sequence}
          workflow={workflow}
          value={loc}
          onChange={handleChange(loc.sequence)}
          allLocations={value}
          onSchedulePickupChange={onSchedulePickupChange}
          schedulePickup={schedulePickup}
          allowDateEdit
          requireEmail={loc.type === 'origin' && requireOriginEmail}
          onAddStop={
            onAddStop &&
            loc.type !== 'destination' &&
            value.length < MAX_LOAD_LOCATIONS
              ? () => onAddStop(loc.sequence)
              : undefined
          }
          onRemoveStop={
            onRemoveStop && loc.type === 'stop'
              ? () => onRemoveStop(loc.sequence)
              : undefined
          }
        />
      ))}
    </>
  )
}
